import React from 'react';
const TermsConditionsPage = () => {
  return <div data-id="element-656">
      {/* Hero Section */}
      <section className="bg-[#0a3d62] text-white py-16" data-id="element-657">
        <div className="container mx-auto px-4" data-id="element-658">
          <div className="max-w-3xl mx-auto text-center" data-id="element-659">
            <h1 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-660">
              Terms & Conditions
            </h1>
            <p className="text-lg text-gray-200" data-id="element-661">
              The terms that govern your use of our website and services
            </p>
          </div>
        </div>
      </section>
      {/* Terms Content */}
      <section className="py-16" data-id="element-662">
        <div className="container mx-auto px-4" data-id="element-663">
          <div className="max-w-3xl mx-auto" data-id="element-664">
            <div className="prose prose-lg max-w-none" data-id="element-665">
              <h2 className="text-2xl font-bold text-[#0a3d62] mb-6" data-id="element-666">
                Terms and Conditions - PinnacleHub
              </h2>
              <h3 className="text-xl font-semibold text-[#0a3d62] mt-8 mb-4" data-id="element-667">
                Overview
              </h3>
              <p className="mb-6" data-id="element-668">
                This website (pinnaclehub.it.com) is operated by PinnacleHub.
                Throughout this site, the terms "we," "us," and "our" refer to
                PinnacleHub. PinnacleHub provides this website, including all
                content, tools, and services, subject to your acceptance of
                these terms, conditions, policies, and notices. These Terms
                govern your use of the PinnacleHub website and your purchase of
                service plans.
              </p>
              <h3 className="text-xl font-semibold text-[#0a3d62] mt-8 mb-4" data-id="element-669">
                Company Information
              </h3>
              <p className="mb-6" data-id="element-670">
                PinnacleHub
                <br data-id="element-671" />
                56 Main St, Glasgow G71 7LS
                <br data-id="element-672" />
                Email: Bikashbuddha2004@gmail.com
                <br data-id="element-673" />
                Customer Support Phone: 0800 055 4969
              </p>
              <h3 className="text-xl font-semibold text-[#0a3d62] mt-8 mb-4" data-id="element-674">
                Service Overview
              </h3>
              <p className="mb-6" data-id="element-675">
                PinnacleHub offers appliance repair and maintenance cover plans.
                Each plan entitles customers to unlimited repairs on covered
                appliances during the subscription period. Full details of each
                plan, including pricing, duration, and inclusions, are clearly
                available on our product and checkout pages.
              </p>
              <h3 className="text-xl font-semibold text-[#0a3d62] mt-8 mb-4" data-id="element-676">
                Pricing and Currency
              </h3>
              <p className="mb-6" data-id="element-677">
                All prices are in GBP (£ - British Pounds Sterling) and all
                charges are processed in GBP. Payments are securely accepted via
                Visa, Mastercard, and other major debit and credit cards.
              </p>
              <h3 className="text-xl font-semibold text-[#0a3d62] mt-8 mb-4" data-id="element-678">
                Order Confirmation
              </h3>
              <p className="mb-6" data-id="element-679">
                After completing your purchase, you'll receive an email
                confirmation. If you don't receive this within one hour, please
                contact Bikashbuddha2004@gmail.com.
              </p>
              <h3 className="text-xl font-semibold text-[#0a3d62] mt-8 mb-4" data-id="element-680">
                Dispute Resolution
              </h3>
              <p className="mb-6" data-id="element-681">
                If you have concerns about your service plan or charges, please
                contact us directly:
              </p>
              <ul className="list-disc pl-6 mb-6" data-id="element-682">
                <li className="mb-2" data-id="element-683">Email: Bikashbuddha2004@gmail.com</li>
                <li className="mb-2" data-id="element-684">Phone: 0800 055 4969</li>
              </ul>
              <p className="mb-6" data-id="element-685">
                We aim to resolve disputes promptly and fairly, with a focus on
                excellent customer service.
              </p>
              <h3 className="text-xl font-semibold text-[#0a3d62] mt-8 mb-4" data-id="element-686">
                Modifications
              </h3>
              <p className="mb-6" data-id="element-687">
                We may revise these Terms from time to time. Continued use of
                our site or services after changes means you accept the updated
                Terms.
              </p>
              <h3 className="text-xl font-semibold text-[#0a3d62] mt-8 mb-4" data-id="element-688">
                Service Plans
              </h3>
              <p className="mb-6" data-id="element-689">
                Our plans cover repair and maintenance for selected appliances.
                Detailed plan information is available on each product page.
              </p>
              <h3 className="text-xl font-semibold text-[#0a3d62] mt-8 mb-4" data-id="element-690">
                Payments
              </h3>
              <p className="mb-6" data-id="element-691">
                We accept secure card payments and Direct Debit. You must be
                authorized to use your chosen payment method.
              </p>
              <h3 className="text-xl font-semibold text-[#0a3d62] mt-8 mb-4" data-id="element-692">
                Cancellation & Refund
              </h3>
              <p className="mb-6" data-id="element-693">
                You can cancel within 14 days of purchase for a full refund.
                Partial refunds may be considered up to 28 days at our
                discretion, depending on whether any services have been
                provided. After 28 days, refunds will no longer be available.
              </p>
              <h3 className="text-xl font-semibold text-[#0a3d62] mt-8 mb-4" data-id="element-694">
                Liability
              </h3>
              <p className="mb-6" data-id="element-695">
                We are not responsible for losses or damages caused by misuse of
                appliances or systems, or from circumstances beyond our
                reasonable control.
              </p>
              <h3 className="text-xl font-semibold text-[#0a3d62] mt-8 mb-4" data-id="element-696">
                Prohibited Use & Plan Exclusions
              </h3>
              <p className="mb-6" data-id="element-697">
                To maintain fair use and service quality, the following are
                excluded from all plans:
              </p>
              <ul className="list-disc pl-6 mb-6" data-id="element-698">
                <li className="mb-2" data-id="element-699">
                  Faults or damage existing before plan activation.
                </li>
                <li className="mb-2" data-id="element-700">
                  Damage caused by misuse, neglect, or tampering.
                </li>
                <li className="mb-2" data-id="element-701">
                  Repairs unrelated to normal appliance function (e.g., cosmetic
                  damage).
                </li>
                <li className="mb-2" data-id="element-702">
                  Illegal or fraudulent use of our services or website.
                </li>
                <li className="mb-2" data-id="element-703">
                  Appliances not used according to manufacturer guidelines.
                </li>
              </ul>
              <p className="mb-6" data-id="element-704">
                If any of these apply, your plan may be cancelled without refund
                or support.
              </p>
              <h3 className="text-xl font-semibold text-[#0a3d62] mt-8 mb-4" data-id="element-705">
                Dispute Resolution (Emphasis)
              </h3>
              <p className="mb-6" data-id="element-706">
                If you have an issue with your service or purchase, please
                contact us first before raising a chargeback with your bank:
              </p>
              <ul className="list-disc pl-6 mb-6" data-id="element-707">
                <li className="mb-2" data-id="element-708">Email: Bikashbuddha2004@gmail.com</li>
                <li className="mb-2" data-id="element-709">Phone: 0800 055 4969</li>
              </ul>
              <p className="mb-6" data-id="element-710">
                We strive to resolve disputes quickly and fairly. Please avoid
                raising chargebacks before speaking with us—we want to help.
              </p>
              <h3 className="text-xl font-semibold text-[#0a3d62] mt-8 mb-4" data-id="element-711">
                Refunds
              </h3>
              <p className="mb-6" data-id="element-712">
                Refunds will be returned to your original payment method. Allow
                5–10 working days for processing depending on your provider.
              </p>
              <h3 className="text-xl font-semibold text-[#0a3d62] mt-8 mb-4" data-id="element-713">
                Terms Acceptance
              </h3>
              <p className="mb-6" data-id="element-714">
                By using our site or purchasing services, you agree to these
                Terms of Service ("Terms"). They apply to all users including
                browsers, customers, vendors, and content contributors. If you
                don't agree to these Terms, please do not use the website or
                services.
              </p>
              <h3 className="text-xl font-semibold text-[#0a3d62] mt-8 mb-4" data-id="element-715">
                New Features
              </h3>
              <p className="mb-6" data-id="element-716">
                Any new tools or features added will also be subject to these
                Terms.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>;
};
export default TermsConditionsPage;